import React, {useState, useEffect} from 'react';
import './css/Message.css'
import Axios from "axios"
import {Alert} from 'react-bootstrap'
import Moment from 'react-moment'
import qs from 'qs'
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"


export default function Message(){   
    
    const key = "6LcEuEIaAAAAAPomCOLxt5YrWYlIIpLOn793v0XX";
    const [name, setName] = useState("")
    const [relation, setRelation] = useState("")
    const [message, setMessage] = useState("")
    const [ipAddress, setIp] = useState("")
    const [listMessage, setListMessage] = useState([])
    const [submitData, setData] = useState()
    const [buttonState, setButtonState] = useState('disabled')
    const [nameisInvalid, setNameInvalid] = useState(false)
    const [messageisInvalid, setMessageInvalid] = useState(false)
    const [showAlert, setAlert] = useState(false)
    const [alertSuccess, setAlertSuccess] = useState(false)
    const [isLoading, setLoading] = useState(false)

    useEffect(() =>{
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${key}`, function () {});
        getIp()
    },[])
    
    useEffect(() =>{
        getData()
    }, [submitData])

    const getIp = () => {
        Axios.get('https://api.ipify.org/?format=json')
        .then((response) =>{
            
            setIp(response.data.ip);

        }).catch(function (error) {

            console.log(error);

        })
    }

    const getData = () => {
        Axios.get('https://sani-rijal-backend.herokuapp.com/api/message/get')
        .then((response) =>{
            
            setListMessage(response.data)

        }).catch(function (error) {

            console.log(error);

        })
    }

    const loadScriptByURL = (id, url, callback) => {
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            script.id = id;
            script.onload = function () {
                if (callback) callback();
            };
            document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
    }

    const validateForm = (e) => {
        if(e.target.id === 'name'){
            setName(e.target.value)
        }else if(e.target.id === 'relation'){
            setRelation(e.target.value)
        }else{
            setMessage(e.target.value)
        }

        if(name === '' || message === ''){
            setButtonState('disabled')
        }else{
            setButtonState('')
        }
        
    }

    const handleClick = e => {
        e.preventDefault();
        
        if (name === '' || message === '') {
            setButtonState('disabled')
            return false;
        }

        if (buttonState === 'disabled') {
            return false;
        }

        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(key, { action: 'submit' }).then(token => {
                submitMessage(token);
            });
        });
    }

    const submitMessage = token => {

        const data = {
            name: name,
            relation: relation,
            message: message,
            ip: ipAddress,
            token: token,
        }
        
        var config = {
            method: 'post',
            url: 'https://sani-rijal-backend.herokuapp.com/api/message/add',
            headers: { 
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify(data),
            transformRequest: [function (data, headers) {
                setLoading(true)
                setButtonState('disabled')
                return data
            }],
          }

        Axios(config).then(() => {
            setName('')
            setMessage('')
            setRelation('')
            setAlert(true)
            setAlertSuccess(true)
            setData([name,message])
            setLoading(false)
            setButtonState('')
            setTimeout(() => {
                setAlert(false)
            }, 2000)

        }).catch(function (error) {
            setAlert(true)
            setAlertSuccess(false)
            setButtonState('')
            setLoading(false)
            setTimeout(() => {
                setAlert(false)
            }, 2000)

        })
    }

    const checkInvalid = (e) => {
        if(e.target.id === 'name'){
            if(name === ''){
                setNameInvalid(true)
            }else{
                setNameInvalid(false)
            }
        }else if(e.target.id === 'message'){
            if(message === ''){
                setMessageInvalid(true)
            }else{
                setMessageInvalid(false)
            }
        }
    }

    const messageList = listMessage.map((d) => 
        <div className="offset-lg-2 col-lg-8 mb-5" key={d.id}>
            <div className="card shadow-sm background-muted-color card-message">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <h5><b>{d.name}</b></h5>
                                    <p className="mb-4 text-muted">{d.relation ? (d.relation) : ''}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 text-center">
                            <p>{d.message}</p>
                        </div>
                    </div>
                </div>
                <div className="col-12 text-right">
                    <small>
                        <Moment format="YYYY-MM-DD HH:mm">
                            {d.date}
                        </Moment>
                    </small>
                </div>
            </div>
        </div>
    );

    return (
        <section className="pt-5 events section-padding section-bg" id="message">
            <div className="container">
                <div className="row" data-aos="zoom-in" data-aos-delay="100">
                    <div className="col-md-12 text-center">
                        <h1 className="section-title">Say Something</h1>
                        <br/>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="offset-lg-3 col-lg-6">
                        <div className="col-md-12 mb-3">
                            <div className="form-group row">
                                <label className={nameisInvalid ? "text-danger" : ""}>Name</label>
                                <div className="input-group">
                                    <input type="text" className={"form-control flat-design " + (nameisInvalid ? "is-invalid" : "") } id="name" name="name" value={name} onKeyUp={(e) => {validateForm(e);checkInvalid(e);}} onChange={validateForm}/>
                                </div>
                                <small id="nameError" className={nameisInvalid ? "text-danger" : ""}>{nameisInvalid ? "FIll out your name" : ""}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group row">
                                <label>Relation <label className="text-muted">(Optional)</label></label>
                                <div className="input-group">
                                    <input type="text" className="form-control flat-design" id="relation" name="relation" value={relation} onKeyUp={(e) => { validateForm(e);}} onChange={validateForm}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group row">
                                <label className={messageisInvalid ? "text-danger" : ""}>Message</label>
                                <div className="input-group">
                                    <textarea type="text" className={"form-control flat-design comment-height " + (messageisInvalid ? "is-invalid" : "") } id="message" name="message"  value={message} onKeyUp={(e) => {validateForm(e);checkInvalid(e);}} onChange={validateForm}/>
                                </div>
                                <small id="messageError" className={messageisInvalid ? "text-danger" : ""}>{messageisInvalid ? "Fill out your message" : ""}</small>
                            </div>
                        </div>
                        <div className="col-12 text-center">
                            <span className={'btn btn-sm btn-primary ' + buttonState} onClick={handleClick}>Send Message {isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin/> : ''}</span>
                        </div>
                    </div>
                </div>
                <Alert show={showAlert} className="text-center" variant={alertSuccess ? "success" : "danger"}>
                    {alertSuccess ? 'Message Sent' : 'Message Failed to Send'}
                </Alert>
                <div className="row message-row">
                    {messageList}
                </div>
            </div>
        </section>
    )
}